import React from "react";
import { motion } from "framer-motion";
import { PROJECTS } from "@/data";

function ProjectCard({ project, index }) {
  const tall = index % 2 === 0;
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`group relative overflow-hidden rounded-sm border border-[#A8AEB2]/15 ${
        tall ? "md:mt-0" : "md:mt-16"
      }`}
      data-testid={`project-card-${index}`}
    >
      <div className={`overflow-hidden ${tall ? "aspect-[4/5]" : "aspect-[4/3]"}`}>
        <img
          src={project.img}
          alt={project.title}
          className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
        />
      </div>
      {/* spotlight overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#14171A] via-transparent to-transparent opacity-90" />
      <div className="absolute bottom-0 left-0 p-6 md:p-8">
        <span className="font-head text-xs uppercase tracking-[0.3em] text-[#7AB648]">
          {project.label}
        </span>
        <h3 className="mt-2 font-head font-bold text-2xl md:text-3xl text-white tracking-tight">
          {project.title}
        </h3>
      </div>
    </motion.div>
  );
}

export default function Projects() {
  return (
    <section
      id="work"
      className="relative z-10 bg-[#14171A] py-20 md:py-32"
      data-testid="projects-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-12 md:mb-20 max-w-2xl"
        >
          <span className="font-body text-sm uppercase tracking-[0.4em] text-[#7AB648]">
            Selected Work
          </span>
          <h2 className="font-display uppercase text-5xl md:text-7xl text-white leading-[0.9] mt-4">
            Built to Last
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
          {PROJECTS.map((project, i) => (
            <ProjectCard key={project.title} project={project} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
